// @flow
import * as React from 'react';
import {
  DataGrid,
  DataGridColumn,
  ListPageWrapper,
  PageTitle,
  useCsrTrackingReportQuery,
  useSessionStorageState
} from '../../shared';
import { CsrTrackingReportOutput, DateRangeInput } from '@coverright/data-access/types/enrollment';
import { Box, Stack, Typography } from '@mui/material';
import moment from 'moment';
import _ from 'lodash';
import { DateRange } from '../../features';
import { useAgentAppointmentsDrawer, withAgentAppointmentsDrawer } from './ui/agent-appointments-drawer';


const Page = () => {
  const {open} = useAgentAppointmentsDrawer();
  const [dateRange, setDateRange] = useDateRange();
  const {loading, data} = useCsrTrackingReportQuery({
    variables: {
      from: moment(dateRange?.from).format('YYYY-MM-DD'),
      to: moment(dateRange?.to).format('YYYY-MM-DD'),
    },
  })

  const rows = data?.csrTrackingReport || [];

  const totalRow = (
    <Box component="tr" className={'info'} sx={{fontWeight: 600, '& td': { backgroundColor: 'primary.50' }, pointerEvents: 'none'}}>
      <td>Total</td>
      <td>{_.sumBy(rows, 'bookedCallsCount')}</td>
      <td>{_.sumBy(rows, 'warmTransfersCount')}</td>
      <td>{_.sumBy(rows, 'nonWarmTransfersAttendedCount')}</td>
      <td>{(_.sumBy(rows, 'nonWarmTransfersAttendedCount') / _.sumBy(rows, 'nonWarmTransfersCount') * 100).toFixed(0) + '%'}</td>
    </Box>
  )

  return (
    <ListPageWrapper>
      <PageTitle title="CSR Tracking Report">
        <Stack direction={'row'} alignItems={'center'} gap={2}>
          <Typography variant={'h4'} sx={{lineHeight: 1, mb: 0}}>Date range:</Typography>
          <DateRange value={dateRange}
                     label={''}
                     onChange={setDateRange} />

        </Stack>

      </PageTitle>

      <DataGrid columns={columns}
                page={0}
                total={1000}
                hidePaginator
                rowsPerPage={1000}
                loading={loading}
                extraRowBuilder={(row, i) => (
                  i === rows.length - 1 ? totalRow : <></>
                )}
                onRowClick={row => dateRange && open(row.agentId, dateRange)}
                rows={rows}/>
    </ListPageWrapper>
  );
};

export const CsrReport = withAgentAppointmentsDrawer(Page)


const columns: DataGridColumn<CsrTrackingReportOutput, keyof CsrTrackingReportOutput>[] = [
  {
    title: 'Email',
    value: v => v.email
  },
  {
    title: 'Booked Appointments',
    value: v => <Typography variant={'body2'}><b>{v.bookedCallsCount}</b></Typography>
  },
  {
    title: 'Warm Transfers',
    value: v => v.warmTransfersCount.toString()
  },
  {
    title: 'Booked Appt Attended',
    value: v => v.nonWarmTransfersAttendedCount.toString()
  },
  {
    title: '% Attendance Rate',
    value: v => (v.nonWarmTransfersAttendedCount / v.nonWarmTransfersCount * 100).toFixed(0) + '%'
  }
]

function useDateRange() {
  return useSessionStorageState<DateRangeInput | undefined>(
    'csrReportDateRange',
    {from: moment().startOf('month').toISOString(), to: moment().endOf('day').toISOString()}
  )
}
